<template>
  <div class="w-[95%] md:w-[45%] lg:w-[30%] mx-auto my-[20px]">
    <div v-if="isLoading">Loading</div>
    <slot v-if="!isLoading && receipt">
      <receipt-content :data="receipt" />
    </slot>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { GetReceipt } from '@/api/payments';
import { notify } from 'notiwind';

import ReceiptContent from '@/components/receipt/ReceiptContent.vue';

const receipt = ref({});
const route = useRoute();

const isLoading = ref(false);

onMounted(async () => {
  try {
    isLoading.value = true;

    const { data: { data } } = await GetReceipt(route.params?.id ?? 'id-is-null');
    receipt.value = data;
  } catch (error) {
    let message;
    if (error.response) {
      message = error.response.data.message;
    }
    message = message ?? 'An error occured while loading the receipt';
    notify(
      {
        variant: 'bg-red-700',
        group: 'foo',
        text: message,
      },
      5000,
    );
  } finally {
    isLoading.value = false;
  }
});
</script>
